// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d0449b3d","667":"d3a31e14"}[chunkId] + ".chunk.js";
};